
import {Component} from './base';


export class CalendarComponent extends Component {
  private filters: any = {titles: [], styles: [], search: null};
  private game: string;

  public static shouldLoad() {
    return $('.calendar').length > 0;
  }

  public register() {
    this.app.eventManager.registerEvent({
      code: 'calendar.load.before'
    });
    this.app.eventManager.registerEvent({
      code: 'calendar.load.after'
    });
  }

  public load() {
    const self = this;

    // Listen to other events.
    this.app.eventManager.listen('calendar-filters.change', function (payload: any) {
      self.updateFilters(payload);
    });

    // Gather facts.
    this.game = $('#hidden-game-short').val() as string;

    // Reload calendar.
    this.initCalendar();
  }

  public reload() {
    $('.calendar').fullCalendar('refetchEvents');
  }

  public updateFilters(payload?: any) {
    this.filters = payload;
    this.reload();
  }

  public initCalendar() {
    $('.calendar').fullCalendar({
      timezone: 'local',
      firstDay: 1,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      buttonText: {
        today: 'Today',
        month: 'Month',
        agendaWeek: 'Week',
        agendaDay: 'Day'
      },
      height: 'auto',
      eventLimit: false,
      events: {
        url: `/calendar/${this.game}/events`,
        data: () => this.getDataPayload(),
        error: () => {
          // todo
        },
      },
      loading: (isLoading: boolean) => {
        if (isLoading) {
          $('.loading').show();
        } else {
          $('.loading').hide();
        }
      },
      eventRender: (event, element, view) => {
        $(element).addClass('mc-calendar-event');
        $(element).tooltip({
          placement: 'right',
          html: true,
          container: 'body',
          template: `
            <div class="tooltip mc-calendar-tooltip" role="tooltip">
              <div class="tooltip-arrow"></div>
              <div class="tooltip-inner"></div>
            </div>`,
          title: `
            <div class="text-left">
              <strong>${event.title}</strong>
              <br><span class="text-muted">Title</span> ${event.titlename}
              <br><span class="text-muted">Style</span> ${event.style}
              <br><span class="text-muted">Tip</span> Click to open the full event page
            </div>`
        });
      },
      timeFormat: 'H:mm',
    });
  }

  public getDataPayload() {
    return {
      game: this.game,
      search: this.filters.hasOwnProperty('search') ? this.filters.search : null,
      titles: this.filters.hasOwnProperty('titles') && this.filters.titles ? this.filters.titles.join('|') : '',
      styles: this.filters.hasOwnProperty('styles') && this.filters.styles ? this.filters.styles.join('|') : '',
    }
  }
}



// WEBPACK FOOTER //
// ./~/source-map-loader!./app/Resources/assets/js/components/calendar.ts